import React from 'react'
import ReturnsIndex from '../features/returns'

console.log("ReturnsPage.jsx");

function Returns() {
  return (
    <ReturnsIndex />
  )
}

export default Returns